import { atom } from "jotai";
import { getVideoPlatform } from "../../../hooks/useVideoPlatform";
import { VideoPlatform } from "../../videoPlatform";
import { zoomTokenAtom } from "../../zoom/state";
import { roomTokenAtom, videoSDKAdapterAtom } from "../atoms";

/**
 * Uses the appropriate video room token based on the current video platform
 */
export const videoRoomTokenAtom = atom(
  (get) => {
    const videoPlatform = getVideoPlatform(get(videoSDKAdapterAtom));

    switch (videoPlatform) {
      case VideoPlatform.Zoom:
        return get(zoomTokenAtom);
      case VideoPlatform.Twilio:
      default:
        return get(roomTokenAtom);
    }
  },
  (get, set, value: string | undefined) => {
    const videoPlatform = getVideoPlatform(get(videoSDKAdapterAtom));
    switch (videoPlatform) {
      case VideoPlatform.Zoom:
        set(zoomTokenAtom, value);
        break;
      case VideoPlatform.Twilio:
      default:
        set(roomTokenAtom, value);
        break;
    }
  },
);
